import { abilityRegistry } from '../player/abilities/AbilityRegistry';
import { getAbilityData } from '../../../shared/content/generated/abilities.gen';

/**
 * True when casting `abilityId` shows the overhead cast bar — the same test
 * CastTimelineSystem's feeders use (RemoteCastRegistry: metadata castTime > 0;
 * castTime is the TOML wind_up_ms, read directly before the registry's TOML
 * resolver is installed).
 * The cast bar already names the ability, so a cast-time float of the same
 * name is a duplicate over the caster's head (plan 15 §2.5). Instant
 * abilities have no bar and keep their name beat.
 */
export function showsCastBar(abilityId: string | null | undefined): boolean {
  if (!abilityId) return false;
  try {
    return (abilityRegistry.getMetadata(abilityId)?.castTime ?? getAbilityData(abilityId)?.windUpMs ?? 0) > 0;
  } catch {
    return false;
  }
}
